import { render, staticRenderFns } from "./RetentionRuleView.vue?vue&type=template&id=7f032e7c&"
import script from "./RetentionRuleView.vue?vue&type=script&lang=js&"
export * from "./RetentionRuleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports